<template>
  <page
    :name="$t('Rinnovo')"
    :title="`Pagamento ${isRecupero ? $t('recupero/conferma ') : $t('rinnovo ')}${
      !products || products.length > 1 ? $t('gruppo') : $t('prodotto')
    }`"
    :state="productsState"
    :empty="!products || !products.length"
  >
    <pf-page-section>
      <payment-report
        :result="Number(route.query.res)"
        :error="$pop(route.query.err)"
        :success="isRecupero ? $t('Recupero/Conferma servizi completato con successo') : $t('Rinnovo servizi completato con successo')"
        route="products"
        :link="$t('Torna alla lista dei prodotti')"
      >
        <x-form
          v-if="importoTotale > 0"
          action="/api/pay_product"
          :submit-text="$t('Conferma il rinnovo')"
          :prevent-submit="!method"
          style="max-width: 80ch"
        >
          <form-group :name="$t('Rinnovo dei prodotti')">
            <pf-list v-for="p in products" :key="p.id">
              <pf-list-item>
                {{ p.nome }} [{{ p.codice }}] {{ p.dominio }}
                <template v-if="p.qt > 1"> (x{{ p.qt }}) </template>
                <template v-if="products.length > 1">
                  - {{ $currency(p.importo, login.currency) }} <small>{{ $t('IVA inclusa') }}</small>
                </template>
              </pf-list-item>
            </pf-list>
            <input v-for="id in ids" :key="id" type="hidden" name="ids[]" :value="id">
          </form-group>

          <payment-methods
            v-model="method"
            :totale-offerta-ivato="importoTotale"
            :currency="login.currency"
          />

          <form-group :name="$t('Riepilogo dei costi')">
            <pf-description-list
              horizontal
              class="payment-totals"
              term-width="30ch"
              style="max-width: 80ch"
            >
              <pf-description-list-group>
                <pf-description-list-term>{{ $t('Totale rinnovo') }}:</pf-description-list-term>
                <pf-description-list-description class="pf-v6-u-text-align-end">
                  {{ $currency(importoTotale, login.currency) }} <span class="vat">({{$t('IVA inclusa')}})</span>
                </pf-description-list-description>
              </pf-description-list-group>
            </pf-description-list>
          </form-group>
        </x-form>
      </payment-report>
    </pf-page-section>
  </page>
</template>

<script lang="ts" setup>
import { ref, type Ref, computed } from 'vue';
import { asyncComputedList } from '@common/asyncComputed';

import PaymentReport from '../components/payment-report.vue';
import PaymentMethods, { type Method} from '../components/payment-methods.vue';
import { useLoginStore } from '@/store/login';
import { ProductOrdersResource, type ProductOrderDetail } from '@/resources';
import { useRoute } from 'vue-router';

const login = useLoginStore();
const route = useRoute();

const ids = route.params.id?.toString().split('-');
const method: Ref<Method | undefined> = ref();

const { state: productsState, result: products } = asyncComputedList(async() => {
  if (ids) {
    return new ProductOrdersResource().get(ids.join('-'));
  }
  return [] as ProductOrderDetail[];
});

const isRecupero = computed(() => products.value.length && ['scaduto', 'non rinnovare'].includes(products.value[0]?.stato_amministrativo ?? ''));

const importoTotale = computed(() => products.value.reduce((sum, product) => sum + product.importo, 0));
</script>
